import { COLORS, pickThemeFontStyles } from '@/theme';
import { Avatar, Button } from '@/ui';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: 2rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
  color: ${COLORS.DARK_PURPLE};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const StyledAvatar = styled(Avatar)`
  --size: 9.5rem;
  width: var(--size);
  height: var(--size);

  .ant-avatar-string {
    font-size: 2.5rem;
  }

  .ant-image-img {
    width: var(--size);
    height: var(--size);
    object-fit: cover;
  }
`;

export const StyledUploadAvatar = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const StyledDeleteButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  display: none;
  z-index: 1;
  visibility: hidden;
`;

export const StyledAvatarWrapper = styled.div`
  position: relative;

  &:hover {
    ${StyledDeleteButton} {
      visibility: visible;
    }
  }
`;

export const StyledWrapper = styled.div`
  max-width: 20rem;
`;
